import { graphql } from "@opensea/graphql"
import { useCollectionTabsFragment } from "./use-collection-tabs.fragment"

export const CollectionNavigationFragment = graphql(
  `
    fragment CollectionNavigation on Collection {
      slug
      ...useCollectionTabs
    }
  `,
  [useCollectionTabsFragment],
)
